import {AxiosError} from 'axios';
import {GET_UPLOADED_FILE_INFO_QUERY_KEY} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {GET_NON_NATIONAL_UPLOADED_FILE_INFO} from '../../constants/apiUrls';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface UploadedFileModel {
  fileUuid: string;
  fileName: string;
  fileSizeInBytes: number;
  submitted: boolean;
}

export interface UploadedFileInfoResponse {
  supportingDocuments: UploadedFileModel[];
  passportPhoto: UploadedFileModel;
  lockedByUser?: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: UploadedFileInfoResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetUploadedFileInfo = ({uuid, onSuccess, onError}: Input) => {
  const getUploadedFileInfo = async () => {
    const res = await axiosClient.get<UploadedFileInfoResponse>(
        GET_NON_NATIONAL_UPLOADED_FILE_INFO(uuid)
    );
    return res.data;
  };

  return useCustomQuery(GET_UPLOADED_FILE_INFO_QUERY_KEY, getUploadedFileInfo, {
    onSuccess,
    onError,
  });
};
